<nb-actions size="small">
  <nb-action icon="edit-outline" [link]="['/pages/customform', companyid,customformid]"></nb-action>
  <nb-action icon="trash-2-outline" (click)="deleteCustomform(deletedialog,customformid)"></nb-action>
</nb-actions>
<ng-template #deletedialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Eliminar Customform</nb-card-header>
    <nb-card-body>Confirmas que quieres eliminar el customform {{ data }}</nb-card-body>
    <nb-card-footer>
    <div class="row">
      <div class="col-md-6">
        <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
      </div>
      <div class="col-md-6 text-right">
        <button nbButton status="danger" (click)="confirmarEliminar(data);ref.close()">Eliminar</button>
      </div>
    </div>


    </nb-card-footer>
  </nb-card>
</ng-template>
